export default function _of(x) {
  return [x];
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/ramda/es/internal/_of.js
// module id = 2211
// module chunks = 0